import { render, staticRenderFns } from "./CcSwitch.ts.vue?vue&type=template&id=8a77b128"
import script from "./CcSwitch.ts.vue?vue&type=script&lang=ts"
export * from "./CcSwitch.ts.vue?vue&type=script&lang=ts"
import style0 from "./CcSwitch.ts.vue?vue&type=style&index=0&id=8a77b128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports